import React, { useEffect, useState, useRef } from 'react'

import styles from './employee.module.scss'
import moment from 'moment'
import { compare } from 'utils'
import { useDispatch } from 'react-redux'
import { ACTION } from 'consts'

//antd
import {
  Popconfirm,
  Input,
  Row,
  Col,
  Select,
  Table,
  Button,
  notification,
  DatePicker,
  Modal,
  Space,
} from 'antd'
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons'

//apis
import { getAllEmployee, deleteEmployee, updateEmployee } from 'apis/staff'
import { getRoles } from 'apis/user'
import { getBranches } from 'apis/branch'

//components
import TitlePage from 'components/title-page'
import EmployeeForm from './employee-form'

const { Option } = Select
export default function Employee() {
  const typingTimeoutRef = useRef(null)
  const dispatch = useDispatch()

  const [users, setUsers] = useState([])
  const [roles, setRoles] = useState([])
  const [countUser, setCountUser] = useState([])
  const [branches, setBranches] = useState([])
  const [loading, setLoading] = useState(false)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })

  const [optionSearch, setOptionSearch] = useState('name')
  const [valueDateSearch, setValueDateSearch] = useState(null)
  const [valueSearch, setValueSearch] = useState('')
  const [valueTime, setValueTime] = useState() //dùng để hiện thị value trong filter by time
  const [valueDateTimeSearch, setValueDateTimeSearch] = useState({})
  const [isOpenSelect, setIsOpenSelect] = useState(false)
  const toggleOpenSelect = () => setIsOpenSelect(!isOpenSelect)

  const onSearch = (e) => {
    const value = e.target.value
    setValueSearch(value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      if (value) paramsFilter[optionSearch] = value
      else delete paramsFilter[optionSearch]

      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 650)
  }

  const _getBranches = async (params) => {
    try {
      const res = await getBranches(params)
      if (res.status === 200) {
        setBranches(res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const ModalUpdateCode = ({ record }) => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)

    const [loading, setLoading] = useState(false)

    const [code, setCode] = useState(record.employee_code || '')

    const _updateCode = async () => {
      try {
        if (!code) {
          notification.warning({ message: 'Vui lòng nhập mã nhân viên!' })
          return
        }
        setLoading(true)
        const res = await updateEmployee(record.user_id, { code: code })
        setLoading(false)
        if (res.status === 200) {
          if (res.data.success) {
            _getUsers()
            notification.success({ message: 'Cập nhật mã nhân viên thành công!' })
          } else
            notification.error({
              message: res.data.message || 'Cập nhật mã nhân viên thất bại, vui lòng thử lại!',
            })
        } else
          notification.error({
            message: res.data.message || 'Cập nhật mã nhân viên thất bại, vui lòng thử lại!',
          })
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    }

    useEffect(() => {
      if (visible) setCode(record.employee_code || '')
    }, [visible])

    return (
      <>
        <a href onClick={toggle}>
          {record.employee_code || ''}
        </a>
        <Modal
          footer={
            <Row justify="end">
              <Space>
                <Button onClick={toggle}>Đóng</Button>
                <Button loading={loading} type="primary" onClick={_updateCode}>
                  Lưu
                </Button>
              </Space>
            </Row>
          }
          title="Cập nhật mã nhân viên"
          visible={visible}
          onCancel={toggle}
        >
          <div>
            <div>Mã nhân viên</div>
            <Input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Nhập mã nhân viên"
              style={{ width: 250 }}
            />
          </div>
        </Modal>
      </>
    )
  }

  const columnsEmployee = [
    {
      title: 'Tên nhân viên',
      render: (text, record) => (
        <EmployeeForm record={record} reloadData={_getUsers}>
          <a>{record.full_name}</a>
        </EmployeeForm>
      ),
    },
    // {
    //   title: 'Mã nhân viên',
    //   dataIndex: 'employee_code',
    //   sorter: (a, b) => compare(a, b, 'code'),
    //   // render: (text, record) => <ModalUpdateCode record={record} />,
    // },
    {
      title: 'Vai trò',
      render: (text, record) => record.role_info && record.role_info.name,
    },
    {
      title: 'Nhà hàng làm việc',
      render: (text, record) => {
        // 2023/04/13 Modify display multiple branch 
        // record.branch_info && record.branch_info.name,
        console.log(record.branch_info);
        if(record.branch_info) {
          if(Array.isArray(record.branch_info)) {
            return record.branch_info.map((info)=> info.name).toString();
          } else {
            return record.branch_info.name;
          }
        }
        return "";
       
      } 
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
      sorter: (a, b) => compare(a, b, 'phone'),
    },
    {
      title: 'Địa chỉ',
      render: (text, record) => record.address || '',
    },
    {
      title: 'Ngày sinh',
      dataIndex: 'birthday',
      sorter: (a, b) => moment(a.birthday).unix() - moment(b.birthday).unix(),
      render: (data) => data && moment(data).format('DD/MM/YYYY'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      sorter: (a, b) => compare(a, b, 'email'),
    },
    {
      title: 'Thời gian đăng kí',
      dataIndex: 'create_date',
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
      render: (data) => data && moment(data).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'Hành động',
      render: (text, record) => (
        <Popconfirm
          cancelText="Từ chối"
          okText="Đồng ý"
          onConfirm={() => _deleteUser(record.user_id)}
          title="Bạn có muốn xóa nhân viên này không?"
        >
          <DeleteOutlined style={{ color: 'red', fontSize: 17, cursor: 'pointer' }} />
        </Popconfirm>
      ),
    },
  ]

  const _clearFilters = () => {
    setParamsFilter({ page: 1, page_size: 20 })
    setValueSearch('')
    setValueTime()
    setValueDateTimeSearch({})
    setValueDateSearch(null)
  }

  const _deleteUser = async (id) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await deleteEmployee({ user_id: [id] })
      dispatch({ type: ACTION.LOADING, data: false })

      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa nhân viên thành công' })
          _getUsers()
        } else
          notification.error({
            message: res.data.message || 'Xóa nhân viên không thất bại, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Xóa nhân viên không thất bại, vui lòng thử lại',
        })
    } catch (err) {
      dispatch({ type: ACTION.LOADING, data: false })
      console.log(err)
    }
  }

  const _getUsers = async () => {
    try {
      setLoading(true)
      const res = await getAllEmployee(paramsFilter)
      if (res.status === 200) {
        setUsers(res.data.data)
        setCountUser(res.data.count)
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const _getRoles = async () => {
    try {
      setLoading(true)
      const res = await getRoles()
      if (res.status === 200) setRoles(res.data.data)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  useEffect(() => {
    _getRoles()
    _getBranches()
  }, [])

  useEffect(() => {
    _getUsers()
  }, [paramsFilter])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <TitlePage title="Quản lý nhân viên">
        <EmployeeForm reloadData={_getUsers}>
          <Button type="primary" size="large">
            Tạo nhân viên
          </Button>
        </EmployeeForm>
      </TitlePage>
      <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Row wrap={false} style={{ width: '100%', border: '1px solid #d9d9d9', borderRadius: 5 }}>
            <Input
              style={{ width: '100%', borderRight: '1px solid #d9d9d9' }}
              placeholder="Tìm kiếm theo..."
              value={valueSearch}
              onChange={(e) => onSearch(e)}
              allowClear
              bordered={false}
              size="large"
            />
            <Select
              style={{ width: 180 }}
              value={optionSearch}
              onChange={(value) => {
                delete paramsFilter[optionSearch]
                setOptionSearch(value)
              }}
              bordered={false}
              size="large"
            >
              <Option value="name">Tên nhân viên</Option>
              <Option value="employee_id">Mã nhân viên</Option>
              <Option value="phone">SĐT nhân viên</Option>
              <Option value="email">Email nhân viên</Option>
            </Select>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Select
            onChange={(value) => {
              if (value) paramsFilter.branch_id = value
              else delete paramsFilter.branch_id
              setParamsFilter({ ...paramsFilter, page: 1 })
            }}
            showSearch
            size="large"
            allowClear
            placeholder="Nhà hàng làm việc"
            style={{ width: '100%' }}
          >
            {branches.map((branch, index) => (
              <Select.Option value={branch.branch_id} key={index}>
                {branch.name}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
          <Select
            size="large"
            open={isOpenSelect}
            onBlur={() => {
              if (isOpenSelect) toggleOpenSelect()
            }}
            onClick={() => {
              if (!isOpenSelect) toggleOpenSelect()
            }}
            allowClear
            showSearch
            style={{ width: '100%' }}
            placeholder="Lọc theo thời gian"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={valueTime}
            onChange={async (value) => {
              setValueTime(value)

              paramsFilter.page = 1

              //xoa params search date hien tai
              const p = Object.keys(valueDateTimeSearch)
              if (p.length) delete paramsFilter[p[0]]

              setValueDateSearch(null)
              delete paramsFilter.from_date
              delete paramsFilter.to_date

              if (isOpenSelect) toggleOpenSelect()

              if (value) {
                const searchDate = Object.fromEntries([[value, true]]) // them params search date moi

                setParamsFilter({ ...paramsFilter, ...searchDate })
                setValueDateTimeSearch({ ...searchDate })
              } else {
                setParamsFilter({ ...paramsFilter })
                setValueDateTimeSearch({})
              }
            }}
            dropdownRender={(menu) => (
              <>
                <DatePicker.RangePicker
                  onFocus={() => {
                    if (!isOpenSelect) toggleOpenSelect()
                  }}
                  onBlur={() => {
                    if (isOpenSelect) toggleOpenSelect()
                  }}
                  value={valueDateSearch}
                  onChange={(dates, dateStrings) => {
                    //khi search hoac filter thi reset page ve 1
                    paramsFilter.page = 1

                    if (isOpenSelect) toggleOpenSelect()

                    //nếu search date thì xoá các params date
                    delete paramsFilter.to_day
                    delete paramsFilter.yesterday
                    delete paramsFilter.this_week
                    delete paramsFilter.last_week
                    delete paramsFilter.last_month
                    delete paramsFilter.this_month
                    delete paramsFilter.this_year
                    delete paramsFilter.last_year

                    //Kiểm tra xem date có được chọn ko
                    //Nếu ko thì thoát khỏi hàm, tránh cash app
                    //và get danh sách order
                    if (!dateStrings[0] && !dateStrings[1]) {
                      delete paramsFilter.from_date
                      delete paramsFilter.to_date

                      setValueDateSearch(null)
                      setValueTime()
                    } else {
                      const dateFirst = dateStrings[0]
                      const dateLast = dateStrings[1]
                      setValueDateSearch(dates)
                      setValueTime(`${dateFirst} -> ${dateLast}`)

                      dateFirst.replace(/-/g, '/')
                      dateLast.replace(/-/g, '/')

                      paramsFilter.from_date = dateFirst
                      paramsFilter.to_date = dateLast
                    }

                    setParamsFilter({ ...paramsFilter })
                  }}
                  style={{ width: '100%' }}
                />
                {menu}
              </>
            )}
          >
            <Option value="today">Hôm nay</Option>
            <Option value="yesterday">Hôm qua</Option>
            <Option value="this_week">Tuần này</Option>
            <Option value="last_week">Tuần trước</Option>
            <Option value="this_month">Tháng này</Option>
            <Option value="last_month">Tháng trước</Option>
            <Option value="this_year">Năm này</Option>
            <Option value="last_year">Năm trước</Option>
          </Select>
        </Col>
        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
          <Select
            allowClear
            style={{ width: '100%' }}
            onChange={(value) => {
              if (value) paramsFilter.role_id = value
              else delete paramsFilter.role_id
              setParamsFilter({ ...paramsFilter, page: 1 })
            }}
            value={paramsFilter.role_id}
            placeholder="Lọc theo vai trò"
            size="large"
          >
            {roles.map((role, index) => (
              <Select.Option value={role.role_id} key={index}>
                {role.name}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Button
          style={{ display: Object.keys(paramsFilter).length < 3 && 'none' }}
          size="large"
          onClick={_clearFilters}
          type="primary"
          danger
        >
          Xóa bộ lọc
        </Button>
      </Row>

      <Table
        loading={loading}
        rowKey="user_id"
        size="small"
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countUser,
        }}
        columns={columnsEmployee}
        dataSource={users}
        style={{ width: '100%', marginTop: 20 }}
      />
    </div>
  )
}
